import { AdvisorDistributionEntry } from '@/redux/types/usageStats'

// Chart slice colors
export const CHART_COLORS = [
  '#3b82f6', // blue-500
  '#d97706', // amber-600 (dark yellow)
  '#ef4444', // red-500
  '#9333ea', // purple-600
  '#0d9488', // teal-600
  '#0ea5e9', // sky-500
  '#16a34a', // green-700 (dark green)
  '#db2777', // pink-600 (magenta)
  '#b45309', // amber-700 (rust)
  '#eab308', // yellow-500 (light yellow)
]

// Empty-state ring color
export const NO_MSG_COLOR = 'rgba(255,255,255,0.20)'

// Activity indicator colors 
export const INDICATOR_GREEN  = '#22c55e'
export const INDICATOR_YELLOW = '#eab308'
export const INDICATOR_RED    = '#ef4444'

// Card background palette
export const BG_COLORS = [
  'bg-gradient-to-br from-[#023572] to-[#012550]',
  'bg-gradient-to-br from-[#008BC0] to-[#006690]',
  'bg-gradient-to-br from-[#008F91] to-[#006668]',
  'bg-gradient-to-br from-[#4A66AC] to-[#334878]',
]

// Dialog gradient equivalents for inline style use in portalled DialogContent
export const DIALOG_GRADIENTS = [
  { top: 'linear-gradient(to bottom, #023572, #012550)', bg: '#012550' },
  { top: 'linear-gradient(to bottom, #008BC0, #006690)', bg: '#006690' },
  { top: 'linear-gradient(to bottom, #008F91, #006668)', bg: '#006668' },
  { top: 'linear-gradient(to bottom, #4A66AC, #334878)', bg: '#334878' },
]

// SVG helpers 

export function polarToCartesian(
  cx: number,
  cy: number,
  r: number,
  angleDeg: number
): { x: number; y: number } {
  const angleRad = ((angleDeg - 90) * Math.PI) / 180
  return {
    x: cx + r * Math.cos(angleRad),
    y: cy + r * Math.sin(angleRad),
  }
}

export function describeArc(
  cx: number,
  cy: number,
  outerR: number,
  innerR: number,
  startAngle: number,
  endAngle: number
): string {
  // Clamp to prevent degenerate full-circle arcs
  const end = endAngle >= 360 ? 359.99 : endAngle
  const o1 = polarToCartesian(cx, cy, outerR, startAngle)
  const o2 = polarToCartesian(cx, cy, outerR, end)
  const i1 = polarToCartesian(cx, cy, innerR, end)
  const i2 = polarToCartesian(cx, cy, innerR, startAngle)
  const large = end - startAngle > 180 ? 1 : 0
  return [
    `M ${o1.x} ${o1.y}`,
    `A ${outerR} ${outerR} 0 ${large} 1 ${o2.x} ${o2.y}`,
    `L ${i1.x} ${i1.y}`,
    `A ${innerR} ${innerR} 0 ${large} 0 ${i2.x} ${i2.y}`,
    'Z',
  ].join(' ')
}

// Activity indicator
export function getActivityColor(
  distribution: AdvisorDistributionEntry[],
  total: number
): string | null {
  if (total === 0 || distribution.length === 0) return null
  const maxCount = Math.max(...distribution.map((d) => d.message_count))
  const maxPct = (maxCount / total) * 100
  if (maxPct <= 45) return INDICATOR_GREEN
  if (maxPct <= 66) return INDICATOR_YELLOW
  return INDICATOR_RED
}
